import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

const isUATEnable = process.env.REACT_APP_UAT_FLAG === 'true';
export const loginApiKeyStore = {
  login: (): MutationKeyConfig => ({
    mutationKey: [`POST_LOGIN`],
    route: `/connect/login`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getUserInfo: (): QueryKeyConfig => ({
    queryKey: [`GET_USER_INFO`],
    route: `/login/user`,
    retry: 0,
  }),
  duxLogin: (): MutationKeyConfig => ({
    mutationKey: [`POST_DUX_LOGIN`],
    route: isUATEnable ? 'https://dux.uatdemo.dev/api/User/Authorize' : `https://web.dux.ws/api/User/Authorize`,
    action: 'POST',
    disableSnackbar: true,
  }),
  logout: (): MutationKeyConfig => ({
    mutationKey: [`POST_LOGOUT`],
    route: `/connect/logout`,
    action: 'POST',
    disableSnackbar: true,
  }),
};
